import React from "react"
import {
  IButton,
  ILink,
  IMediaAsset,
} from "packages/gatsby-theme-strapi/gatsby-graphql"
import { Button, Heading } from "../../ui"
import { ButtonType } from "../../ui/button/button-elements"
import {
  Buttons,
  ContentWrapper,
  Description,
  InfoBoxWrapper,
  SectionWrapper,
} from "./info-box-elements"
import { SectionProps } from "../section-loader"

interface InfoBoxProps extends SectionProps {
  data: {
    heading?: string
    description?: string
    buttons?: IButton[]
    background?: IMediaAsset
  }
}

const InfoBox = ({ data, locale }: InfoBoxProps) => {
  return (
    <SectionWrapper bgImg={data.background?.url as string}>
      <ContentWrapper>
        <Heading.H2 textTransform="uppercase">{data.heading}</Heading.H2>
        <InfoBoxWrapper>
          {data.description && <Description>{data.description}</Description>}
          {data.buttons && data.buttons.length > 0 && (
            <Buttons>
              {data.buttons.map((button, index) => (
                <Button
                  type={button?.type as ButtonType}
                  link={button?.link as ILink}
                  locale={locale}
                  key={index}
                />
              ))}
            </Buttons>
          )}
        </InfoBoxWrapper>
      </ContentWrapper>
    </SectionWrapper>
  )
}

export default InfoBox
